import React, { Component } from 'react';
import { Size } from '../_util/enum';
import Menu from '../menu';
import Dropdown from '../dropdown';
import Icon from '../icon';
import Button from '../button';
import message from '../message';
import FilterDropdownMenuWrapper from './FilterDropdownMenuWrapper';
import ColumnFilterMenuItem from './ColumnFilterMenuItem';
import { getColumnKey } from './util';
function getParentNode(triggerNode) {
    return triggerNode.parentNode;
}
export default class ColumnFilterMenu extends Component {
    constructor(props) {
        super(props);
        this.items = {}; // 存储编辑的 column 的组件的 ref
        this.handleEditChange = (editing) => {
            const { prevCustomColumns } = this.state;
            this.setState({
                editing,
                customColumns: prevCustomColumns,
            });
        };
        // 渲染标题旁边的 icon
        this.renderFilterIcon = () => {
            const { locale } = this.props;
            return React.createElement(Icon, { title: locale.filterTitle, className: "custom-bars", type: "format_list_bulleted" });
        };
        // 确认按钮点击
        this.handleConfirmBtnClick = () => {
            const { columns = [], confirmFilter, store } = this.props;
            const customColumnsGetPromise = [];
            columns
                .map((column, index) => getColumnKey(column, index))
                .forEach((key) => {
                const columnFilterMenuItem = this.items[key];
                if (columnFilterMenuItem) {
                    customColumnsGetPromise.push(columnFilterMenuItem.getValidateCustomColumn());
                }
            });
            Promise.all(customColumnsGetPromise).then(([...customColumns]) => {
                this.setState({
                    customColumns,
                    editing: false,
                });
                store.setState({ customColumns });
                confirmFilter(customColumns);
            }, (err) => {
                message.error(err && err.message);
            });
        };
        // 获取编辑组件的 ref
        this.handleItemRef = (key, element) => {
            this.items[key] = element;
        };
        this.state = {
            editing: false,
            customColumns: props.customColumns || [],
            prevCustomColumns: props.customColumns || [],
        };
    }
    static getDerivedStateFromProps(nextProps, prevState) {
        const { customColumns } = nextProps;
        const { prevCustomColumns } = prevState;
        if (customColumns && customColumns !== prevCustomColumns) {
            return {
                customColumns,
                prevCustomColumns: customColumns,
            };
        }
        return null;
    }
    render() {
        const { locale, prefixCls, dropdownProps, getPopupContainer } = this.props;
        const dropdownPrefixCls = dropdownProps.prefixCls;
        const { editing } = this.state;
        const editTitle = this.renderEditTitle();
        const editContent = this.renderEditContent(); // this.renderMenus(columns)
        const menus = (React.createElement(FilterDropdownMenuWrapper, { className: `${prefixCls}-dropdown custom-column-dropdown` },
            React.createElement("div", { className: `${dropdownPrefixCls}-menu-item` }, editTitle),
            React.createElement(Menu, { multiple: true, prefixCls: `${dropdownPrefixCls}-menu`, getPopupContainer: getParentNode }, editContent),
            React.createElement("div", { className: `${prefixCls}-dropdown-btns` },
                React.createElement(Button, { size: Size.small, className: `${prefixCls}-dropdown-link confirm`, onClick: this.handleConfirmBtnClick }, locale.filterConfirm))));
        return (React.createElement(Dropdown, Object.assign({}, dropdownProps, { trigger: ['click'], overlay: menus, visible: editing, onVisibleChange: this.handleEditChange, getPopupContainer: getPopupContainer, forceRender: true }), this.renderFilterIcon()));
    }
    renderEditItem(column, index) {
        const { checkboxPrefixCls, inputNumberProps } = this.props;
        const { customColumns } = this.state;
        const key = getColumnKey(column);
        const customColumn = customColumns.find((fCustomColumn) => fCustomColumn.fieldKey === key);
        return (React.createElement(Menu.Item, { key: key },
            React.createElement(ColumnFilterMenuItem, { inputNumberProps: inputNumberProps, checkboxPrefixCls: checkboxPrefixCls, customColumn: customColumn, column: column, index: index, ref: (item) => this.handleItemRef(key, item) })));
    }
    // 渲染编辑的标题
    renderEditTitle() {
        const { filterBarLocale } = this.props;
        const { display, field, fixedLeft, orderSeq } = filterBarLocale || {};
        return (React.createElement("div", null,
            React.createElement("div", { className: "dropdown-menu-text" }, display),
            React.createElement("div", { className: "dropdown-menu-text" }, field),
            React.createElement("div", { className: "dropdown-menu-text" }, fixedLeft),
            React.createElement("div", { className: "dropdown-menu-text" }, orderSeq)));
    }
    // 渲染编辑区域内容
    renderEditContent() {
        const { columns = [] } = this.props;
        return columns.map((column, index) => {
            return this.renderEditItem(column, index);
        });
    }
}
